<div class="d-flex flex-column">
    <div class="d-flex flex-row">
        <app-detail-info-card class="policy-info" [data]="policyInfo" [disableShadow]="true"></app-detail-info-card>
    </div>
</div>